export default __webpack_public_path__ + "static/media/dispatch_later_category.edd095ed.svg";